import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 32px;

  h2 {
    font-size: 18px;
    font-weight: 400;
    margin: 0 0 36px 0;
    color: #4b4d4e;
  }
`;

export const Footer = styled.div`
  text-align: left;

  > * {
    margin-right: 20px;
  }
`;
